import { Space, Spin } from 'antd';
import React from 'react';

interface Props {
  icon?: React.ReactNode;
  title?: string | React.ReactNode;
  children: React.ReactNode;
  extraBtns?: any;
  isLoading?: boolean;
  titleClassName?: string;
  noBackgroundColor?: boolean;
}

const MainContent = ({ isLoading = false, ...props }: Props) => {
  return (
    <Spin spinning={isLoading}>
      <div style={{ minHeight: '100%', backgroundColor: props.noBackgroundColor ? 'unset' : 'white' }}>
        <div className="app-page-title">
          {props.title || props.extraBtns ? (
            <div className="title-header">
              {props.title && <div className={`title ${props.titleClassName || ''}`}>{props.title}</div>}

              <div className="extra-btns">
                <Space>{props.extraBtns}</Space>
              </div>
            </div>
          ) : null}
          <div className="app-content">{props.children}</div>
        </div>
      </div>
    </Spin>
  );
};

export default React.memo(MainContent);
